import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ec9f2296 = () => interopDefault(import('../pages/introduce.vue' /* webpackChunkName: "pages/introduce" */))
const _1daecb7c = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _b8dc1d78 = () => interopDefault(import('../pages/logOut.vue' /* webpackChunkName: "pages/logOut" */))
const _31685fe3 = () => interopDefault(import('../pages/questions.vue' /* webpackChunkName: "pages/questions" */))
const _0f29f403 = () => interopDefault(import('../pages/seller-rules.vue' /* webpackChunkName: "pages/seller-rules" */))
const _4e74fad6 = () => interopDefault(import('../pages/store-login/index.vue' /* webpackChunkName: "pages/store-login/index" */))
const _f24b26ee = () => interopDefault(import('../pages/create-seller-account/entry.vue' /* webpackChunkName: "pages/create-seller-account/entry" */))
const _20c0f1b5 = () => interopDefault(import('../pages/create-seller-account/Redirect.vue' /* webpackChunkName: "pages/create-seller-account/Redirect" */))
const _1dfc7508 = () => interopDefault(import('../pages/create-seller-account/step1.vue' /* webpackChunkName: "pages/create-seller-account/step1" */))
const _1de04606 = () => interopDefault(import('../pages/create-seller-account/step2.vue' /* webpackChunkName: "pages/create-seller-account/step2" */))
const _1dc41704 = () => interopDefault(import('../pages/create-seller-account/step3.vue' /* webpackChunkName: "pages/create-seller-account/step3" */))
const _1da7e802 = () => interopDefault(import('../pages/create-seller-account/step4.vue' /* webpackChunkName: "pages/create-seller-account/step4" */))
const _1d8bb900 = () => interopDefault(import('../pages/create-seller-account/step5.vue' /* webpackChunkName: "pages/create-seller-account/step5" */))
const _a3eddcc2 = () => interopDefault(import('../pages/print/afterShippingPrint.vue' /* webpackChunkName: "pages/print/afterShippingPrint" */))
const _5939d174 = () => interopDefault(import('../pages/print/expressReturn.vue' /* webpackChunkName: "pages/print/expressReturn" */))
const _9ebc8acc = () => interopDefault(import('../pages/print/list.vue' /* webpackChunkName: "pages/print/list" */))
const _205dbbcc = () => interopDefault(import('../pages/seller-center/accountmanagement.vue' /* webpackChunkName: "pages/seller-center/accountmanagement" */))
const _89d17062 = () => interopDefault(import('../pages/seller-center/acproductsignup.vue' /* webpackChunkName: "pages/seller-center/acproductsignup" */))
const _708e6990 = () => interopDefault(import('../pages/seller-center/activitybigpromotion.vue' /* webpackChunkName: "pages/seller-center/activitybigpromotion" */))
const _11fd2e3e = () => interopDefault(import('../pages/seller-center/activityfalsh.vue' /* webpackChunkName: "pages/seller-center/activityfalsh" */))
const _27c9caab = () => interopDefault(import('../pages/seller-center/activityflash.vue' /* webpackChunkName: "pages/seller-center/activityflash" */))
const _13c6f1ba = () => interopDefault(import('../pages/seller-center/activitygroup.vue' /* webpackChunkName: "pages/seller-center/activitygroup" */))
const _7a2a69ec = () => interopDefault(import('../pages/seller-center/activityintegrate.vue' /* webpackChunkName: "pages/seller-center/activityintegrate" */))
const _2d2f0744 = () => interopDefault(import('../pages/seller-center/activitypromotion.vue' /* webpackChunkName: "pages/seller-center/activitypromotion" */))
const _06558826 = () => interopDefault(import('../pages/seller-center/activitysignup.vue' /* webpackChunkName: "pages/seller-center/activitysignup" */))
const _1a0f13c5 = () => interopDefault(import('../pages/seller-center/activitytd.vue' /* webpackChunkName: "pages/seller-center/activitytd" */))
const _0d5f4636 = () => interopDefault(import('../pages/seller-center/aftersales.vue' /* webpackChunkName: "pages/seller-center/aftersales" */))
const _6c3d14e4 = () => interopDefault(import('../pages/seller-center/apply-warehouse.vue' /* webpackChunkName: "pages/seller-center/apply-warehouse" */))
const _ea609308 = () => interopDefault(import('../pages/seller-center/bigpromotionmine.vue' /* webpackChunkName: "pages/seller-center/bigpromotionmine" */))
const _afe9d15c = () => interopDefault(import('../pages/seller-center/catset.vue' /* webpackChunkName: "pages/seller-center/catset" */))
const _20c01984 = () => interopDefault(import('../pages/seller-center/clearing/index.vue' /* webpackChunkName: "pages/seller-center/clearing/index" */))
const _407eaa62 = () => interopDefault(import('../pages/seller-center/closeStore.vue' /* webpackChunkName: "pages/seller-center/closeStore" */))
const _6a61e2d6 = () => interopDefault(import('../pages/seller-center/coinsplan.vue' /* webpackChunkName: "pages/seller-center/coinsplan" */))
const _07cadd97 = () => interopDefault(import('../pages/seller-center/cps-dashboard.vue' /* webpackChunkName: "pages/seller-center/cps-dashboard" */))
const _7b547ad1 = () => interopDefault(import('../pages/seller-center/cps-order.vue' /* webpackChunkName: "pages/seller-center/cps-order" */))
const _768e68ed = () => interopDefault(import('../pages/seller-center/cps-product-config.vue' /* webpackChunkName: "pages/seller-center/cps-product-config" */))
const _cb053f16 = () => interopDefault(import('../pages/seller-center/developinfo.vue' /* webpackChunkName: "pages/seller-center/developinfo" */))
const _29169d3a = () => interopDefault(import('../pages/seller-center/express-account.vue' /* webpackChunkName: "pages/seller-center/express-account" */))
const _68bce6cc = () => interopDefault(import('../pages/seller-center/extendedprice.vue' /* webpackChunkName: "pages/seller-center/extendedprice" */))
const _555abb3b = () => interopDefault(import('../pages/seller-center/fullfunctionediting.vue' /* webpackChunkName: "pages/seller-center/fullfunctionediting" */))
const _9d2722aa = () => interopDefault(import('../pages/seller-center/fund-account.vue' /* webpackChunkName: "pages/seller-center/fund-account" */))
const _343568bc = () => interopDefault(import('../pages/seller-center/gallery.vue' /* webpackChunkName: "pages/seller-center/gallery" */))
const _810a7ed8 = () => interopDefault(import('../pages/seller-center/groupsignupmine.vue' /* webpackChunkName: "pages/seller-center/groupsignupmine" */))
const _74874965 = () => interopDefault(import('../pages/seller-center/home.vue' /* webpackChunkName: "pages/seller-center/home" */))
const _52fde423 = () => interopDefault(import('../pages/seller-center/liquidation.vue' /* webpackChunkName: "pages/seller-center/liquidation" */))
const _1c3d61de = () => interopDefault(import('../pages/seller-center/margin-and-disclaimer-info.vue' /* webpackChunkName: "pages/seller-center/margin-and-disclaimer-info" */))
const _3c72287a = () => interopDefault(import('../pages/seller-center/margin-turnover.vue' /* webpackChunkName: "pages/seller-center/margin-turnover" */))
const _492e5cb4 = () => interopDefault(import('../pages/seller-center/message/index.vue' /* webpackChunkName: "pages/seller-center/message/index" */))
const _51be98b2 = () => interopDefault(import('../pages/seller-center/postage-strategy.vue' /* webpackChunkName: "pages/seller-center/postage-strategy" */))
const _1a0600e7 = () => interopDefault(import('../pages/seller-center/postage-strategy-mixins.js' /* webpackChunkName: "pages/seller-center/postage-strategy-mixins" */))
const _568866c8 = () => interopDefault(import('../pages/seller-center/printingBatchCode.vue' /* webpackChunkName: "pages/seller-center/printingBatchCode" */))
const _6715e5f7 = () => interopDefault(import('../pages/seller-center/printingBatchRestockBox.vue' /* webpackChunkName: "pages/seller-center/printingBatchRestockBox" */))
const _6a0572b0 = () => interopDefault(import('../pages/seller-center/printingCode.vue' /* webpackChunkName: "pages/seller-center/printingCode" */))
const _1b9ea703 = () => interopDefault(import('../pages/seller-center/printingRestockBox.vue' /* webpackChunkName: "pages/seller-center/printingRestockBox" */))
const _2c8979a0 = () => interopDefault(import('../pages/seller-center/printingStockBoxNew.vue' /* webpackChunkName: "pages/seller-center/printingStockBoxNew" */))
const _1b0750f7 = () => interopDefault(import('../pages/seller-center/productlist.vue' /* webpackChunkName: "pages/seller-center/productlist" */))
const _ac941e5c = () => interopDefault(import('../pages/seller-center/productreviews.vue' /* webpackChunkName: "pages/seller-center/productreviews" */))
const _23b6afd4 = () => interopDefault(import('../pages/seller-center/promotionallist.vue' /* webpackChunkName: "pages/seller-center/promotionallist" */))
const _1c864639 = () => interopDefault(import('../pages/seller-center/recommendproduct.vue' /* webpackChunkName: "pages/seller-center/recommendproduct" */))
const _5eaa469c = () => interopDefault(import('../pages/seller-center/reviewList.vue' /* webpackChunkName: "pages/seller-center/reviewList" */))
const _36ebb6f4 = () => interopDefault(import('../pages/seller-center/securitiesbatch.vue' /* webpackChunkName: "pages/seller-center/securitiesbatch" */))
const _185b3a27 = () => interopDefault(import('../pages/seller-center/securitiesmanagement.vue' /* webpackChunkName: "pages/seller-center/securitiesmanagement" */))
const _44585dde = () => interopDefault(import('../pages/seller-center/securitiestemplate.vue' /* webpackChunkName: "pages/seller-center/securitiestemplate" */))
const _17c8c8e2 = () => interopDefault(import('../pages/seller-center/ShopNews.vue' /* webpackChunkName: "pages/seller-center/ShopNews" */))
const _36d80a44 = () => interopDefault(import('../pages/seller-center/stockup-product-list.vue' /* webpackChunkName: "pages/seller-center/stockup-product-list" */))
const _00535e93 = () => interopDefault(import('../pages/seller-center/store-postage-strategy.vue' /* webpackChunkName: "pages/seller-center/store-postage-strategy" */))
const _80b1ff16 = () => interopDefault(import('../pages/seller-center/storeaccountmanagement.vue' /* webpackChunkName: "pages/seller-center/storeaccountmanagement" */))
const _25e0112e = () => interopDefault(import('../pages/seller-center/storelist.vue' /* webpackChunkName: "pages/seller-center/storelist" */))
const _48c12798 = () => interopDefault(import('../pages/seller-center/storesetting/index.vue' /* webpackChunkName: "pages/seller-center/storesetting/index" */))
const _15d22611 = () => interopDefault(import('../pages/seller-center/system-notify.vue' /* webpackChunkName: "pages/seller-center/system-notify" */))
const _5f375c8e = () => interopDefault(import('../pages/seller-center/tdsignup.vue' /* webpackChunkName: "pages/seller-center/tdsignup" */))
const _4e4f973e = () => interopDefault(import('../pages/seller-center/tdsignupmine.vue' /* webpackChunkName: "pages/seller-center/tdsignupmine" */))
const _b1106354 = () => interopDefault(import('../pages/seller-center/activity/application.vue' /* webpackChunkName: "pages/seller-center/activity/application" */))
const _2ab27a2d = () => interopDefault(import('../pages/seller-center/activity/SetDealPriceDialog.vue' /* webpackChunkName: "pages/seller-center/activity/SetDealPriceDialog" */))
const _17ba2316 = () => interopDefault(import('../pages/seller-center/address/newAfteReturn.vue' /* webpackChunkName: "pages/seller-center/address/newAfteReturn" */))
const _6d0428b3 = () => interopDefault(import('../pages/seller-center/address/newAfteShipping.vue' /* webpackChunkName: "pages/seller-center/address/newAfteShipping" */))
const _0ad384b1 = () => interopDefault(import('../pages/seller-center/address/return.vue' /* webpackChunkName: "pages/seller-center/address/return" */))
const _cc2fc022 = () => interopDefault(import('../pages/seller-center/address/shipping.vue' /* webpackChunkName: "pages/seller-center/address/shipping" */))
const _f105f89a = () => interopDefault(import('../pages/seller-center/after-sale/deliveryList.vue' /* webpackChunkName: "pages/seller-center/after-sale/deliveryList" */))
const _5acd9ec2 = () => interopDefault(import('../pages/seller-center/after-sale/list.vue' /* webpackChunkName: "pages/seller-center/after-sale/list" */))
const _2b3340ed = () => interopDefault(import('../pages/seller-center/after-sale/newList.vue' /* webpackChunkName: "pages/seller-center/after-sale/newList" */))
const _7bb035e0 = () => interopDefault(import('../pages/seller-center/after-sale/outboundLogisticsList.vue' /* webpackChunkName: "pages/seller-center/after-sale/outboundLogisticsList" */))
const _b6591ffa = () => interopDefault(import('../pages/seller-center/bill/billQuiry.vue' /* webpackChunkName: "pages/seller-center/bill/billQuiry" */))
const _526930a3 = () => interopDefault(import('../pages/seller-center/bill/settlement-bill-beakdown.vue' /* webpackChunkName: "pages/seller-center/bill/settlement-bill-beakdown" */))
const _32c7fd14 = () => interopDefault(import('../pages/seller-center/bill/settlement-bill-documents.vue' /* webpackChunkName: "pages/seller-center/bill/settlement-bill-documents" */))
const _4d41a3f6 = () => interopDefault(import('../pages/seller-center/bill/settlement-entity.vue' /* webpackChunkName: "pages/seller-center/bill/settlement-entity" */))
const _c69cf7d6 = () => interopDefault(import('../pages/seller-center/clearing/detail.vue' /* webpackChunkName: "pages/seller-center/clearing/detail" */))
const _0f7a246b = () => interopDefault(import('../pages/seller-center/cms/home.vue' /* webpackChunkName: "pages/seller-center/cms/home" */))
const _218fddf0 = () => interopDefault(import('../pages/seller-center/complaint/list.vue' /* webpackChunkName: "pages/seller-center/complaint/list" */))
const _1b3e36d9 = () => interopDefault(import('../pages/seller-center/expense-appeal/expense-appeal.vue' /* webpackChunkName: "pages/seller-center/expense-appeal/expense-appeal" */))
const _76b3f216 = () => interopDefault(import('../pages/seller-center/expense-appeal/expense-appeal-detail.vue' /* webpackChunkName: "pages/seller-center/expense-appeal/expense-appeal-detail" */))
const _6ffd9493 = () => interopDefault(import('../pages/seller-center/expense-appeal/logistics-expense-appeal.vue' /* webpackChunkName: "pages/seller-center/expense-appeal/logistics-expense-appeal" */))
const _9c22b80a = () => interopDefault(import('../pages/seller-center/expense-appeal/logistics-expense-appeal-detail.vue' /* webpackChunkName: "pages/seller-center/expense-appeal/logistics-expense-appeal-detail" */))
const _6c6aa618 = () => interopDefault(import('../pages/seller-center/expense-appeal/mall-expense-appeal.vue' /* webpackChunkName: "pages/seller-center/expense-appeal/mall-expense-appeal" */))
const _195364c4 = () => interopDefault(import('../pages/seller-center/expense-appeal/pay-expense-appeal.vue' /* webpackChunkName: "pages/seller-center/expense-appeal/pay-expense-appeal" */))
const _23028af3 = () => interopDefault(import('../pages/seller-center/express/returnList.vue' /* webpackChunkName: "pages/seller-center/express/returnList" */))
const _bacfcfcc = () => interopDefault(import('../pages/seller-center/express/scrapList.vue' /* webpackChunkName: "pages/seller-center/express/scrapList" */))
const _72daeafc = () => interopDefault(import('../pages/seller-center/flashSale/application.vue' /* webpackChunkName: "pages/seller-center/flashSale/application" */))
const _47981b40 = () => interopDefault(import('../pages/seller-center/flashSale/applicationList.vue' /* webpackChunkName: "pages/seller-center/flashSale/applicationList" */))
const _7fdcb207 = () => interopDefault(import('../pages/seller-center/flashSale/applicationManage.vue' /* webpackChunkName: "pages/seller-center/flashSale/applicationManage" */))
const _b165e918 = () => interopDefault(import('../pages/seller-center/flashSale/details.vue' /* webpackChunkName: "pages/seller-center/flashSale/details" */))
const _58b2ca3a = () => interopDefault(import('../pages/seller-center/flashSale/rule.vue' /* webpackChunkName: "pages/seller-center/flashSale/rule" */))
const _a014c2e6 = () => interopDefault(import('../pages/seller-center/fundAccount/appeal-fbk-info.vue' /* webpackChunkName: "pages/seller-center/fundAccount/appeal-fbk-info" */))
const _4642228b = () => interopDefault(import('../pages/seller-center/fundAccount/fbk-inventory-appeal.vue' /* webpackChunkName: "pages/seller-center/fundAccount/fbk-inventory-appeal" */))
const _dda00d40 = () => interopDefault(import('../pages/seller-center/fundAccount/new-appeal-fbk-info.vue' /* webpackChunkName: "pages/seller-center/fundAccount/new-appeal-fbk-info" */))
const _ac1738b2 = () => interopDefault(import('../pages/seller-center/fundAccount/store-margin.vue' /* webpackChunkName: "pages/seller-center/fundAccount/store-margin" */))
const _5f3a84f2 = () => interopDefault(import('../pages/seller-center/gift/list.vue' /* webpackChunkName: "pages/seller-center/gift/list" */))
const _94a06ef0 = () => interopDefault(import('../pages/seller-center/gift/usage.vue' /* webpackChunkName: "pages/seller-center/gift/usage" */))
const _685ea65e = () => interopDefault(import('../pages/seller-center/goods/add-goods-success.vue' /* webpackChunkName: "pages/seller-center/goods/add-goods-success" */))
const _1cbbc9dc = () => interopDefault(import('../pages/seller-center/goods/draft.vue' /* webpackChunkName: "pages/seller-center/goods/draft" */))
const _5acbe168 = () => interopDefault(import('../pages/seller-center/goods/edit-goods-success.vue' /* webpackChunkName: "pages/seller-center/goods/edit-goods-success" */))
const _1c7a4946 = () => interopDefault(import('../pages/seller-center/goods/mixin.js' /* webpackChunkName: "pages/seller-center/goods/mixin" */))
const _ef69945e = () => interopDefault(import('../pages/seller-center/goods/new.vue' /* webpackChunkName: "pages/seller-center/goods/new" */))
const _b8990f08 = () => interopDefault(import('../pages/seller-center/goods/warrantyPropMixin.js' /* webpackChunkName: "pages/seller-center/goods/warrantyPropMixin" */))
const _0168de8a = () => interopDefault(import('../pages/seller-center/goods/warrantyPropValidate.js' /* webpackChunkName: "pages/seller-center/goods/warrantyPropValidate" */))
const _465a5cd5 = () => interopDefault(import('../pages/seller-center/insights/productReport.vue' /* webpackChunkName: "pages/seller-center/insights/productReport" */))
const _65df74ad = () => interopDefault(import('../pages/seller-center/insights/storePerformance.vue' /* webpackChunkName: "pages/seller-center/insights/storePerformance" */))
const _6d7ca8c7 = () => interopDefault(import('../pages/seller-center/insights/storeReport.vue' /* webpackChunkName: "pages/seller-center/insights/storeReport" */))
const _fa200c04 = () => interopDefault(import('../pages/seller-center/limited-time-deal/available-list.vue' /* webpackChunkName: "pages/seller-center/limited-time-deal/available-list" */))
const _3dfab742 = () => interopDefault(import('../pages/seller-center/limited-time-deal/product-manage.vue' /* webpackChunkName: "pages/seller-center/limited-time-deal/product-manage" */))
const _5ab9c423 = () => interopDefault(import('../pages/seller-center/logistics/costSheets.vue' /* webpackChunkName: "pages/seller-center/logistics/costSheets" */))
const _5799a2ad = () => interopDefault(import('../pages/seller-center/logistics/costSheetsNew.vue' /* webpackChunkName: "pages/seller-center/logistics/costSheetsNew" */))
const _f8b806ca = () => interopDefault(import('../pages/seller-center/logistics/headAccount.vue' /* webpackChunkName: "pages/seller-center/logistics/headAccount" */))
const _bd58580a = () => interopDefault(import('../pages/seller-center/logistics/wallet.vue' /* webpackChunkName: "pages/seller-center/logistics/wallet" */))
const _7a9db0b1 = () => interopDefault(import('../pages/seller-center/message/admin.vue' /* webpackChunkName: "pages/seller-center/message/admin" */))
const _74cb8ce6 = () => interopDefault(import('../pages/seller-center/message/seller.vue' /* webpackChunkName: "pages/seller-center/message/seller" */))
const _af6e1676 = () => interopDefault(import('../pages/seller-center/order/list.vue' /* webpackChunkName: "pages/seller-center/order/list" */))
const _568a3bfc = () => interopDefault(import('../pages/seller-center/order/logistics.vue' /* webpackChunkName: "pages/seller-center/order/logistics" */))
const _1c4b3b4e = () => interopDefault(import('../pages/seller-center/order/status.vue' /* webpackChunkName: "pages/seller-center/order/status" */))
const _1752187b = () => interopDefault(import('../pages/seller-center/restock/plan.vue' /* webpackChunkName: "pages/seller-center/restock/plan" */))
const _1ec701cc = () => interopDefault(import('../pages/seller-center/stock-up/apply/index.vue' /* webpackChunkName: "pages/seller-center/stock-up/apply/index" */))
const _ffbbc176 = () => interopDefault(import('../pages/seller-center/stock-up/list.vue' /* webpackChunkName: "pages/seller-center/stock-up/list" */))
const _9e089710 = () => interopDefault(import('../pages/seller-center/storesetting/ValidInput.vue' /* webpackChunkName: "pages/seller-center/storesetting/ValidInput" */))
const _65a80b4a = () => interopDefault(import('../pages/shippage/widgets/CentralizedPackage.vue' /* webpackChunkName: "pages/shippage/widgets/CentralizedPackage" */))
const _124b13cc = () => interopDefault(import('../pages/seller-center/address/components/AddressList.vue' /* webpackChunkName: "pages/seller-center/address/components/AddressList" */))
const _2f8473a1 = () => interopDefault(import('../pages/seller-center/address/components/kilishopDialog.vue' /* webpackChunkName: "pages/seller-center/address/components/kilishopDialog" */))
const _5ab369a6 = () => interopDefault(import('../pages/seller-center/address/components/RepairEntrustSettings.vue' /* webpackChunkName: "pages/seller-center/address/components/RepairEntrustSettings" */))
const _56789145 = () => interopDefault(import('../pages/seller-center/application/seller/edit.vue' /* webpackChunkName: "pages/seller-center/application/seller/edit" */))
const _240fcbe3 = () => interopDefault(import('../pages/seller-center/bill/fee/aftersales-deduction.vue' /* webpackChunkName: "pages/seller-center/bill/fee/aftersales-deduction" */))
const _45554872 = () => interopDefault(import('../pages/seller-center/bill/fee/express-compensation.vue' /* webpackChunkName: "pages/seller-center/bill/fee/express-compensation" */))
const _5ead5820 = () => interopDefault(import('../pages/seller-center/bill/fee/logistics-deduction.vue' /* webpackChunkName: "pages/seller-center/bill/fee/logistics-deduction" */))
const _ea68ce98 = () => interopDefault(import('../pages/seller-center/bill/fee/order-cancel.vue' /* webpackChunkName: "pages/seller-center/bill/fee/order-cancel" */))
const _d6106408 = () => interopDefault(import('../pages/seller-center/bill/fee/product-violation.vue' /* webpackChunkName: "pages/seller-center/bill/fee/product-violation" */))
const _58f58502 = () => interopDefault(import('../pages/seller-center/bill/fee/repair-cost.vue' /* webpackChunkName: "pages/seller-center/bill/fee/repair-cost" */))
const _419c89ae = () => interopDefault(import('../pages/seller-center/bill/fee/settlement-arrear.vue' /* webpackChunkName: "pages/seller-center/bill/fee/settlement-arrear" */))
const _93a49c28 = () => interopDefault(import('../pages/seller-center/fundAccount/widgets/appealCard.vue' /* webpackChunkName: "pages/seller-center/fundAccount/widgets/appealCard" */))
const _1b7a2cda = () => interopDefault(import('../pages/seller-center/goods/widgets/batchApply.vue' /* webpackChunkName: "pages/seller-center/goods/widgets/batchApply" */))
const _5bf58362 = () => interopDefault(import('../pages/seller-center/goods/widgets/CustomSelector.vue' /* webpackChunkName: "pages/seller-center/goods/widgets/CustomSelector" */))
const _17ff521e = () => interopDefault(import('../pages/seller-center/goods/widgets/EditGoodsCategoryModel.vue' /* webpackChunkName: "pages/seller-center/goods/widgets/EditGoodsCategoryModel" */))
const _4857eb7a = () => interopDefault(import('../pages/seller-center/goods/widgets/EditorCategoryHistory.vue' /* webpackChunkName: "pages/seller-center/goods/widgets/EditorCategoryHistory" */))
const _6dd2ecea = () => interopDefault(import('../pages/seller-center/goods/widgets/editSuccess.vue' /* webpackChunkName: "pages/seller-center/goods/widgets/editSuccess" */))
const _5b1f3d27 = () => interopDefault(import('../pages/seller-center/goods/widgets/PhysicalInventoryDetail.vue' /* webpackChunkName: "pages/seller-center/goods/widgets/PhysicalInventoryDetail" */))
const _6a6deacd = () => interopDefault(import('../pages/seller-center/goods/widgets/productsku-mixins.js' /* webpackChunkName: "pages/seller-center/goods/widgets/productsku-mixins" */))
const _0049c070 = () => interopDefault(import('../pages/seller-center/limited-time-deal/widgets/BatchSettingsListingsDialog.vue' /* webpackChunkName: "pages/seller-center/limited-time-deal/widgets/BatchSettingsListingsDialog" */))
const _40a94506 = () => interopDefault(import('../pages/seller-center/limited-time-deal/widgets/ListingTable.vue' /* webpackChunkName: "pages/seller-center/limited-time-deal/widgets/ListingTable" */))
const _d1cc2456 = () => interopDefault(import('../pages/seller-center/message/widgets/AfterSaleCard.vue' /* webpackChunkName: "pages/seller-center/message/widgets/AfterSaleCard" */))
const _d9d09090 = () => interopDefault(import('../pages/seller-center/message/widgets/ChooseModal.vue' /* webpackChunkName: "pages/seller-center/message/widgets/ChooseModal" */))
const _e6ed9514 = () => interopDefault(import('../pages/seller-center/message/widgets/MediaCard.vue' /* webpackChunkName: "pages/seller-center/message/widgets/MediaCard" */))
const _4b37563b = () => interopDefault(import('../pages/seller-center/message/widgets/MsgToolsBar.vue' /* webpackChunkName: "pages/seller-center/message/widgets/MsgToolsBar" */))
const _560b7a40 = () => interopDefault(import('../pages/seller-center/message/widgets/OrderCard.vue' /* webpackChunkName: "pages/seller-center/message/widgets/OrderCard" */))
const _1c128d01 = () => interopDefault(import('../pages/seller-center/message/widgets/ProductCard.vue' /* webpackChunkName: "pages/seller-center/message/widgets/ProductCard" */))
const _5883530d = () => interopDefault(import('../pages/seller-center/message/widgets/VideoCard.vue' /* webpackChunkName: "pages/seller-center/message/widgets/VideoCard" */))
const _516b1fc0 = () => interopDefault(import('../pages/seller-center/message/widgets/VoucherCard.vue' /* webpackChunkName: "pages/seller-center/message/widgets/VoucherCard" */))
const _02c39cf4 = () => interopDefault(import('../pages/seller-center/stock-up/apply/list.vue' /* webpackChunkName: "pages/seller-center/stock-up/apply/list" */))
const _64a38b54 = () => interopDefault(import('../pages/seller-center/stock-up/new/list.vue' /* webpackChunkName: "pages/seller-center/stock-up/new/list" */))
const _8cca5b04 = () => interopDefault(import('../pages/seller-center/stock-up/new/logic/stock-ship-helper.js' /* webpackChunkName: "pages/seller-center/stock-up/new/logic/stock-ship-helper" */))
const _2f713cb8 = () => interopDefault(import('../pages/seller-center/application/store/application/_id.vue' /* webpackChunkName: "pages/seller-center/application/store/application/_id" */))
const _03999670 = () => interopDefault(import('../pages/seller-center/application/store/edit/_id.vue' /* webpackChunkName: "pages/seller-center/application/store/edit/_id" */))
const _2cfc9117 = () => interopDefault(import('../pages/seller-center/application/store/qualification/_id.vue' /* webpackChunkName: "pages/seller-center/application/store/qualification/_id" */))
const _551e3663 = () => interopDefault(import('../pages/seller-center/application/store/view/_id.vue' /* webpackChunkName: "pages/seller-center/application/store/view/_id" */))
const _fea3755a = () => interopDefault(import('../pages/seller-center/stock-up/new/apply/_id.vue' /* webpackChunkName: "pages/seller-center/stock-up/new/apply/_id" */))
const _0907718a = () => interopDefault(import('../pages/seller-center/after-sale/details/_newId.vue' /* webpackChunkName: "pages/seller-center/after-sale/details/_newId" */))
const _3fb954e3 = () => interopDefault(import('../pages/seller-center/order/detail/_id.vue' /* webpackChunkName: "pages/seller-center/order/detail/_id" */))
const _57938002 = () => interopDefault(import('../pages/seller-center/stock-up/apply/_id.vue' /* webpackChunkName: "pages/seller-center/stock-up/apply/_id" */))
const _94969718 = () => interopDefault(import('../pages/seller-center/stock-up/new/_id.vue' /* webpackChunkName: "pages/seller-center/stock-up/new/_id" */))
const _22bf0d90 = () => interopDefault(import('../pages/seller-center/deposit-payment-record/_id.vue' /* webpackChunkName: "pages/seller-center/deposit-payment-record/_id" */))
const _2fc53e02 = () => interopDefault(import('../pages/seller-center/detailshow/_id.vue' /* webpackChunkName: "pages/seller-center/detailshow/_id" */))
const _384849f6 = () => interopDefault(import('../pages/seller-center/dialogueinterface/_id.vue' /* webpackChunkName: "pages/seller-center/dialogueinterface/_id" */))
const _063e0c82 = () => interopDefault(import('../pages/seller-center/fault-lisclaimer-list/_id.vue' /* webpackChunkName: "pages/seller-center/fault-lisclaimer-list/_id" */))
const _f5e9433a = () => interopDefault(import('../pages/seller-center/stock-up/_id.vue' /* webpackChunkName: "pages/seller-center/stock-up/_id" */))
const _2758bea7 = () => interopDefault(import('../pages/sellerApp/logistics/_id.vue' /* webpackChunkName: "pages/sellerApp/logistics/_id" */))
const _ff7c2830 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _389008a6 = () => interopDefault(import('../pages/_lang/index.vue' /* webpackChunkName: "pages/_lang/index" */))
const _2851b080 = () => interopDefault(import('../pages/_lang/login/index.vue' /* webpackChunkName: "pages/_lang/login/index" */))
const _6e3b46c7 = () => interopDefault(import('../pages/_lang/create-seller-account/entry.vue' /* webpackChunkName: "pages/_lang/create-seller-account/entry" */))
const _4f3ac08c = () => interopDefault(import('../pages/_lang/create-seller-account/step1.vue' /* webpackChunkName: "pages/_lang/create-seller-account/step1" */))
const _4f1e918a = () => interopDefault(import('../pages/_lang/create-seller-account/step2.vue' /* webpackChunkName: "pages/_lang/create-seller-account/step2" */))
const _4f026288 = () => interopDefault(import('../pages/_lang/create-seller-account/step3.vue' /* webpackChunkName: "pages/_lang/create-seller-account/step3" */))
const _4ee63386 = () => interopDefault(import('../pages/_lang/create-seller-account/step4.vue' /* webpackChunkName: "pages/_lang/create-seller-account/step4" */))
const _4eca0484 = () => interopDefault(import('../pages/_lang/create-seller-account/step5.vue' /* webpackChunkName: "pages/_lang/create-seller-account/step5" */))
const _3483ed68 = () => interopDefault(import('../pages/-Iframe.js' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/introduce",
    component: _ec9f2296,
    name: "introduce"
  }, {
    path: "/login",
    component: _1daecb7c,
    name: "login"
  }, {
    path: "/logOut",
    component: _b8dc1d78,
    name: "logOut"
  }, {
    path: "/questions",
    component: _31685fe3,
    name: "questions"
  }, {
    path: "/seller-rules",
    component: _0f29f403,
    name: "seller-rules"
  }, {
    path: "/store-login",
    component: _4e74fad6,
    name: "store-login"
  }, {
    path: "/create-seller-account/entry",
    component: _f24b26ee,
    name: "create-seller-account-entry"
  }, {
    path: "/create-seller-account/Redirect",
    component: _20c0f1b5,
    name: "create-seller-account-Redirect"
  }, {
    path: "/create-seller-account/step1",
    component: _1dfc7508,
    name: "create-seller-account-step1"
  }, {
    path: "/create-seller-account/step2",
    component: _1de04606,
    name: "create-seller-account-step2"
  }, {
    path: "/create-seller-account/step3",
    component: _1dc41704,
    name: "create-seller-account-step3"
  }, {
    path: "/create-seller-account/step4",
    component: _1da7e802,
    name: "create-seller-account-step4"
  }, {
    path: "/create-seller-account/step5",
    component: _1d8bb900,
    name: "create-seller-account-step5"
  }, {
    path: "/print/afterShippingPrint",
    component: _a3eddcc2,
    name: "print-afterShippingPrint"
  }, {
    path: "/print/expressReturn",
    component: _5939d174,
    name: "print-expressReturn"
  }, {
    path: "/print/list",
    component: _9ebc8acc,
    name: "print-list"
  }, {
    path: "/seller-center/accountmanagement",
    component: _205dbbcc,
    name: "seller-center-accountmanagement"
  }, {
    path: "/seller-center/acproductsignup",
    component: _89d17062,
    name: "seller-center-acproductsignup"
  }, {
    path: "/seller-center/activitybigpromotion",
    component: _708e6990,
    name: "seller-center-activitybigpromotion"
  }, {
    path: "/seller-center/activityfalsh",
    component: _11fd2e3e,
    name: "seller-center-activityfalsh"
  }, {
    path: "/seller-center/activityflash",
    component: _27c9caab,
    name: "seller-center-activityflash"
  }, {
    path: "/seller-center/activitygroup",
    component: _13c6f1ba,
    name: "seller-center-activitygroup"
  }, {
    path: "/seller-center/activityintegrate",
    component: _7a2a69ec,
    name: "seller-center-activityintegrate"
  }, {
    path: "/seller-center/activitypromotion",
    component: _2d2f0744,
    name: "seller-center-activitypromotion"
  }, {
    path: "/seller-center/activitysignup",
    component: _06558826,
    name: "seller-center-activitysignup"
  }, {
    path: "/seller-center/activitytd",
    component: _1a0f13c5,
    name: "seller-center-activitytd"
  }, {
    path: "/seller-center/aftersales",
    component: _0d5f4636,
    name: "seller-center-aftersales"
  }, {
    path: "/seller-center/apply-warehouse",
    component: _6c3d14e4,
    name: "seller-center-apply-warehouse"
  }, {
    path: "/seller-center/bigpromotionmine",
    component: _ea609308,
    name: "seller-center-bigpromotionmine"
  }, {
    path: "/seller-center/catset",
    component: _afe9d15c,
    name: "seller-center-catset"
  }, {
    path: "/seller-center/clearing",
    component: _20c01984,
    name: "seller-center-clearing"
  }, {
    path: "/seller-center/closeStore",
    component: _407eaa62,
    name: "seller-center-closeStore"
  }, {
    path: "/seller-center/coinsplan",
    component: _6a61e2d6,
    name: "seller-center-coinsplan"
  }, {
    path: "/seller-center/cps-dashboard",
    component: _07cadd97,
    name: "seller-center-cps-dashboard"
  }, {
    path: "/seller-center/cps-order",
    component: _7b547ad1,
    name: "seller-center-cps-order"
  }, {
    path: "/seller-center/cps-product-config",
    component: _768e68ed,
    name: "seller-center-cps-product-config"
  }, {
    path: "/seller-center/developinfo",
    component: _cb053f16,
    name: "seller-center-developinfo"
  }, {
    path: "/seller-center/express-account",
    component: _29169d3a,
    name: "seller-center-express-account"
  }, {
    path: "/seller-center/extendedprice",
    component: _68bce6cc,
    name: "seller-center-extendedprice"
  }, {
    path: "/seller-center/fullfunctionediting",
    component: _555abb3b,
    name: "seller-center-fullfunctionediting"
  }, {
    path: "/seller-center/fund-account",
    component: _9d2722aa,
    name: "seller-center-fund-account"
  }, {
    path: "/seller-center/gallery",
    component: _343568bc,
    name: "seller-center-gallery"
  }, {
    path: "/seller-center/groupsignupmine",
    component: _810a7ed8,
    name: "seller-center-groupsignupmine"
  }, {
    path: "/seller-center/home",
    component: _74874965,
    name: "seller-center-home"
  }, {
    path: "/seller-center/liquidation",
    component: _52fde423,
    name: "seller-center-liquidation"
  }, {
    path: "/seller-center/margin-and-disclaimer-info",
    component: _1c3d61de,
    name: "seller-center-margin-and-disclaimer-info"
  }, {
    path: "/seller-center/margin-turnover",
    component: _3c72287a,
    name: "seller-center-margin-turnover"
  }, {
    path: "/seller-center/message",
    component: _492e5cb4,
    name: "seller-center-message"
  }, {
    path: "/seller-center/postage-strategy",
    component: _51be98b2,
    name: "seller-center-postage-strategy"
  }, {
    path: "/seller-center/postage-strategy-mixins",
    component: _1a0600e7,
    name: "seller-center-postage-strategy-mixins"
  }, {
    path: "/seller-center/printingBatchCode",
    component: _568866c8,
    name: "seller-center-printingBatchCode"
  }, {
    path: "/seller-center/printingBatchRestockBox",
    component: _6715e5f7,
    name: "seller-center-printingBatchRestockBox"
  }, {
    path: "/seller-center/printingCode",
    component: _6a0572b0,
    name: "seller-center-printingCode"
  }, {
    path: "/seller-center/printingRestockBox",
    component: _1b9ea703,
    name: "seller-center-printingRestockBox"
  }, {
    path: "/seller-center/printingStockBoxNew",
    component: _2c8979a0,
    name: "seller-center-printingStockBoxNew"
  }, {
    path: "/seller-center/productlist",
    component: _1b0750f7,
    name: "seller-center-productlist"
  }, {
    path: "/seller-center/productreviews",
    component: _ac941e5c,
    name: "seller-center-productreviews"
  }, {
    path: "/seller-center/promotionallist",
    component: _23b6afd4,
    name: "seller-center-promotionallist"
  }, {
    path: "/seller-center/recommendproduct",
    component: _1c864639,
    name: "seller-center-recommendproduct"
  }, {
    path: "/seller-center/reviewList",
    component: _5eaa469c,
    name: "seller-center-reviewList"
  }, {
    path: "/seller-center/securitiesbatch",
    component: _36ebb6f4,
    name: "seller-center-securitiesbatch"
  }, {
    path: "/seller-center/securitiesmanagement",
    component: _185b3a27,
    name: "seller-center-securitiesmanagement"
  }, {
    path: "/seller-center/securitiestemplate",
    component: _44585dde,
    name: "seller-center-securitiestemplate"
  }, {
    path: "/seller-center/ShopNews",
    component: _17c8c8e2,
    name: "seller-center-ShopNews"
  }, {
    path: "/seller-center/stockup-product-list",
    component: _36d80a44,
    name: "seller-center-stockup-product-list"
  }, {
    path: "/seller-center/store-postage-strategy",
    component: _00535e93,
    name: "seller-center-store-postage-strategy"
  }, {
    path: "/seller-center/storeaccountmanagement",
    component: _80b1ff16,
    name: "seller-center-storeaccountmanagement"
  }, {
    path: "/seller-center/storelist",
    component: _25e0112e,
    name: "seller-center-storelist"
  }, {
    path: "/seller-center/storesetting",
    component: _48c12798,
    name: "seller-center-storesetting"
  }, {
    path: "/seller-center/system-notify",
    component: _15d22611,
    name: "seller-center-system-notify"
  }, {
    path: "/seller-center/tdsignup",
    component: _5f375c8e,
    name: "seller-center-tdsignup"
  }, {
    path: "/seller-center/tdsignupmine",
    component: _4e4f973e,
    name: "seller-center-tdsignupmine"
  }, {
    path: "/seller-center/activity/application",
    component: _b1106354,
    name: "seller-center-activity-application"
  }, {
    path: "/seller-center/activity/SetDealPriceDialog",
    component: _2ab27a2d,
    name: "seller-center-activity-SetDealPriceDialog"
  }, {
    path: "/seller-center/address/newAfteReturn",
    component: _17ba2316,
    name: "seller-center-address-newAfteReturn"
  }, {
    path: "/seller-center/address/newAfteShipping",
    component: _6d0428b3,
    name: "seller-center-address-newAfteShipping"
  }, {
    path: "/seller-center/address/return",
    component: _0ad384b1,
    name: "seller-center-address-return"
  }, {
    path: "/seller-center/address/shipping",
    component: _cc2fc022,
    name: "seller-center-address-shipping"
  }, {
    path: "/seller-center/after-sale/deliveryList",
    component: _f105f89a,
    name: "seller-center-after-sale-deliveryList"
  }, {
    path: "/seller-center/after-sale/list",
    component: _5acd9ec2,
    name: "seller-center-after-sale-list"
  }, {
    path: "/seller-center/after-sale/newList",
    component: _2b3340ed,
    name: "seller-center-after-sale-newList"
  }, {
    path: "/seller-center/after-sale/outboundLogisticsList",
    component: _7bb035e0,
    name: "seller-center-after-sale-outboundLogisticsList"
  }, {
    path: "/seller-center/bill/billQuiry",
    component: _b6591ffa,
    name: "seller-center-bill-billQuiry"
  }, {
    path: "/seller-center/bill/settlement-bill-beakdown",
    component: _526930a3,
    name: "seller-center-bill-settlement-bill-beakdown"
  }, {
    path: "/seller-center/bill/settlement-bill-documents",
    component: _32c7fd14,
    name: "seller-center-bill-settlement-bill-documents"
  }, {
    path: "/seller-center/bill/settlement-entity",
    component: _4d41a3f6,
    name: "seller-center-bill-settlement-entity"
  }, {
    path: "/seller-center/clearing/detail",
    component: _c69cf7d6,
    name: "seller-center-clearing-detail"
  }, {
    path: "/seller-center/cms/home",
    component: _0f7a246b,
    name: "seller-center-cms-home"
  }, {
    path: "/seller-center/complaint/list",
    component: _218fddf0,
    name: "seller-center-complaint-list"
  }, {
    path: "/seller-center/expense-appeal/expense-appeal",
    component: _1b3e36d9,
    name: "seller-center-expense-appeal-expense-appeal"
  }, {
    path: "/seller-center/expense-appeal/expense-appeal-detail",
    component: _76b3f216,
    name: "seller-center-expense-appeal-expense-appeal-detail"
  }, {
    path: "/seller-center/expense-appeal/logistics-expense-appeal",
    component: _6ffd9493,
    name: "seller-center-expense-appeal-logistics-expense-appeal"
  }, {
    path: "/seller-center/expense-appeal/logistics-expense-appeal-detail",
    component: _9c22b80a,
    name: "seller-center-expense-appeal-logistics-expense-appeal-detail"
  }, {
    path: "/seller-center/expense-appeal/mall-expense-appeal",
    component: _6c6aa618,
    name: "seller-center-expense-appeal-mall-expense-appeal"
  }, {
    path: "/seller-center/expense-appeal/pay-expense-appeal",
    component: _195364c4,
    name: "seller-center-expense-appeal-pay-expense-appeal"
  }, {
    path: "/seller-center/express/returnList",
    component: _23028af3,
    name: "seller-center-express-returnList"
  }, {
    path: "/seller-center/express/scrapList",
    component: _bacfcfcc,
    name: "seller-center-express-scrapList"
  }, {
    path: "/seller-center/flashSale/application",
    component: _72daeafc,
    name: "seller-center-flashSale-application"
  }, {
    path: "/seller-center/flashSale/applicationList",
    component: _47981b40,
    name: "seller-center-flashSale-applicationList"
  }, {
    path: "/seller-center/flashSale/applicationManage",
    component: _7fdcb207,
    name: "seller-center-flashSale-applicationManage"
  }, {
    path: "/seller-center/flashSale/details",
    component: _b165e918,
    name: "seller-center-flashSale-details"
  }, {
    path: "/seller-center/flashSale/rule",
    component: _58b2ca3a,
    name: "seller-center-flashSale-rule"
  }, {
    path: "/seller-center/fundAccount/appeal-fbk-info",
    component: _a014c2e6,
    name: "seller-center-fundAccount-appeal-fbk-info"
  }, {
    path: "/seller-center/fundAccount/fbk-inventory-appeal",
    component: _4642228b,
    name: "seller-center-fundAccount-fbk-inventory-appeal"
  }, {
    path: "/seller-center/fundAccount/new-appeal-fbk-info",
    component: _dda00d40,
    name: "seller-center-fundAccount-new-appeal-fbk-info"
  }, {
    path: "/seller-center/fundAccount/store-margin",
    component: _ac1738b2,
    name: "seller-center-fundAccount-store-margin"
  }, {
    path: "/seller-center/gift/list",
    component: _5f3a84f2,
    name: "seller-center-gift-list"
  }, {
    path: "/seller-center/gift/usage",
    component: _94a06ef0,
    name: "seller-center-gift-usage"
  }, {
    path: "/seller-center/goods/add-goods-success",
    component: _685ea65e,
    name: "seller-center-goods-add-goods-success"
  }, {
    path: "/seller-center/goods/draft",
    component: _1cbbc9dc,
    name: "seller-center-goods-draft"
  }, {
    path: "/seller-center/goods/edit-goods-success",
    component: _5acbe168,
    name: "seller-center-goods-edit-goods-success"
  }, {
    path: "/seller-center/goods/mixin",
    component: _1c7a4946,
    name: "seller-center-goods-mixin"
  }, {
    path: "/seller-center/goods/new",
    component: _ef69945e,
    name: "seller-center-goods-new"
  }, {
    path: "/seller-center/goods/warrantyPropMixin",
    component: _b8990f08,
    name: "seller-center-goods-warrantyPropMixin"
  }, {
    path: "/seller-center/goods/warrantyPropValidate",
    component: _0168de8a,
    name: "seller-center-goods-warrantyPropValidate"
  }, {
    path: "/seller-center/insights/productReport",
    component: _465a5cd5,
    name: "seller-center-insights-productReport"
  }, {
    path: "/seller-center/insights/storePerformance",
    component: _65df74ad,
    name: "seller-center-insights-storePerformance"
  }, {
    path: "/seller-center/insights/storeReport",
    component: _6d7ca8c7,
    name: "seller-center-insights-storeReport"
  }, {
    path: "/seller-center/limited-time-deal/available-list",
    component: _fa200c04,
    name: "seller-center-limited-time-deal-available-list"
  }, {
    path: "/seller-center/limited-time-deal/product-manage",
    component: _3dfab742,
    name: "seller-center-limited-time-deal-product-manage"
  }, {
    path: "/seller-center/logistics/costSheets",
    component: _5ab9c423,
    name: "seller-center-logistics-costSheets"
  }, {
    path: "/seller-center/logistics/costSheetsNew",
    component: _5799a2ad,
    name: "seller-center-logistics-costSheetsNew"
  }, {
    path: "/seller-center/logistics/headAccount",
    component: _f8b806ca,
    name: "seller-center-logistics-headAccount"
  }, {
    path: "/seller-center/logistics/wallet",
    component: _bd58580a,
    name: "seller-center-logistics-wallet"
  }, {
    path: "/seller-center/message/admin",
    component: _7a9db0b1,
    name: "seller-center-message-admin"
  }, {
    path: "/seller-center/message/seller",
    component: _74cb8ce6,
    name: "seller-center-message-seller"
  }, {
    path: "/seller-center/order/list",
    component: _af6e1676,
    name: "seller-center-order-list"
  }, {
    path: "/seller-center/order/logistics",
    component: _568a3bfc,
    name: "seller-center-order-logistics"
  }, {
    path: "/seller-center/order/status",
    component: _1c4b3b4e,
    name: "seller-center-order-status"
  }, {
    path: "/seller-center/restock/plan",
    component: _1752187b,
    name: "seller-center-restock-plan"
  }, {
    path: "/seller-center/stock-up/apply",
    component: _1ec701cc,
    name: "seller-center-stock-up-apply"
  }, {
    path: "/seller-center/stock-up/list",
    component: _ffbbc176,
    name: "seller-center-stock-up-list"
  }, {
    path: "/seller-center/storesetting/ValidInput",
    component: _9e089710,
    name: "seller-center-storesetting-ValidInput"
  }, {
    path: "/shippage/widgets/CentralizedPackage",
    component: _65a80b4a,
    name: "shippage-widgets-CentralizedPackage"
  }, {
    path: "/seller-center/address/components/AddressList",
    component: _124b13cc,
    name: "seller-center-address-components-AddressList"
  }, {
    path: "/seller-center/address/components/kilishopDialog",
    component: _2f8473a1,
    name: "seller-center-address-components-kilishopDialog"
  }, {
    path: "/seller-center/address/components/RepairEntrustSettings",
    component: _5ab369a6,
    name: "seller-center-address-components-RepairEntrustSettings"
  }, {
    path: "/seller-center/application/seller/edit",
    component: _56789145,
    name: "seller-center-application-seller-edit"
  }, {
    path: "/seller-center/bill/fee/aftersales-deduction",
    component: _240fcbe3,
    name: "seller-center-bill-fee-aftersales-deduction"
  }, {
    path: "/seller-center/bill/fee/express-compensation",
    component: _45554872,
    name: "seller-center-bill-fee-express-compensation"
  }, {
    path: "/seller-center/bill/fee/logistics-deduction",
    component: _5ead5820,
    name: "seller-center-bill-fee-logistics-deduction"
  }, {
    path: "/seller-center/bill/fee/order-cancel",
    component: _ea68ce98,
    name: "seller-center-bill-fee-order-cancel"
  }, {
    path: "/seller-center/bill/fee/product-violation",
    component: _d6106408,
    name: "seller-center-bill-fee-product-violation"
  }, {
    path: "/seller-center/bill/fee/repair-cost",
    component: _58f58502,
    name: "seller-center-bill-fee-repair-cost"
  }, {
    path: "/seller-center/bill/fee/settlement-arrear",
    component: _419c89ae,
    name: "seller-center-bill-fee-settlement-arrear"
  }, {
    path: "/seller-center/fundAccount/widgets/appealCard",
    component: _93a49c28,
    name: "seller-center-fundAccount-widgets-appealCard"
  }, {
    path: "/seller-center/goods/widgets/batchApply",
    component: _1b7a2cda,
    name: "seller-center-goods-widgets-batchApply"
  }, {
    path: "/seller-center/goods/widgets/CustomSelector",
    component: _5bf58362,
    name: "seller-center-goods-widgets-CustomSelector"
  }, {
    path: "/seller-center/goods/widgets/EditGoodsCategoryModel",
    component: _17ff521e,
    name: "seller-center-goods-widgets-EditGoodsCategoryModel"
  }, {
    path: "/seller-center/goods/widgets/EditorCategoryHistory",
    component: _4857eb7a,
    name: "seller-center-goods-widgets-EditorCategoryHistory"
  }, {
    path: "/seller-center/goods/widgets/editSuccess",
    component: _6dd2ecea,
    name: "seller-center-goods-widgets-editSuccess"
  }, {
    path: "/seller-center/goods/widgets/PhysicalInventoryDetail",
    component: _5b1f3d27,
    name: "seller-center-goods-widgets-PhysicalInventoryDetail"
  }, {
    path: "/seller-center/goods/widgets/productsku-mixins",
    component: _6a6deacd,
    name: "seller-center-goods-widgets-productsku-mixins"
  }, {
    path: "/seller-center/limited-time-deal/widgets/BatchSettingsListingsDialog",
    component: _0049c070,
    name: "seller-center-limited-time-deal-widgets-BatchSettingsListingsDialog"
  }, {
    path: "/seller-center/limited-time-deal/widgets/ListingTable",
    component: _40a94506,
    name: "seller-center-limited-time-deal-widgets-ListingTable"
  }, {
    path: "/seller-center/message/widgets/AfterSaleCard",
    component: _d1cc2456,
    name: "seller-center-message-widgets-AfterSaleCard"
  }, {
    path: "/seller-center/message/widgets/ChooseModal",
    component: _d9d09090,
    name: "seller-center-message-widgets-ChooseModal"
  }, {
    path: "/seller-center/message/widgets/MediaCard",
    component: _e6ed9514,
    name: "seller-center-message-widgets-MediaCard"
  }, {
    path: "/seller-center/message/widgets/MsgToolsBar",
    component: _4b37563b,
    name: "seller-center-message-widgets-MsgToolsBar"
  }, {
    path: "/seller-center/message/widgets/OrderCard",
    component: _560b7a40,
    name: "seller-center-message-widgets-OrderCard"
  }, {
    path: "/seller-center/message/widgets/ProductCard",
    component: _1c128d01,
    name: "seller-center-message-widgets-ProductCard"
  }, {
    path: "/seller-center/message/widgets/VideoCard",
    component: _5883530d,
    name: "seller-center-message-widgets-VideoCard"
  }, {
    path: "/seller-center/message/widgets/VoucherCard",
    component: _516b1fc0,
    name: "seller-center-message-widgets-VoucherCard"
  }, {
    path: "/seller-center/stock-up/apply/list",
    component: _02c39cf4,
    name: "seller-center-stock-up-apply-list"
  }, {
    path: "/seller-center/stock-up/new/list",
    component: _64a38b54,
    name: "seller-center-stock-up-new-list"
  }, {
    path: "/seller-center/stock-up/new/logic/stock-ship-helper",
    component: _8cca5b04,
    name: "seller-center-stock-up-new-logic-stock-ship-helper"
  }, {
    path: "/seller-center/application/store/application/:id?",
    component: _2f713cb8,
    name: "seller-center-application-store-application-id"
  }, {
    path: "/seller-center/application/store/edit/:id?",
    component: _03999670,
    name: "seller-center-application-store-edit-id"
  }, {
    path: "/seller-center/application/store/qualification/:id?",
    component: _2cfc9117,
    name: "seller-center-application-store-qualification-id"
  }, {
    path: "/seller-center/application/store/view/:id?",
    component: _551e3663,
    name: "seller-center-application-store-view-id"
  }, {
    path: "/seller-center/stock-up/new/apply/:id?",
    component: _fea3755a,
    name: "seller-center-stock-up-new-apply-id"
  }, {
    path: "/seller-center/after-sale/details/:newId?",
    component: _0907718a,
    name: "seller-center-after-sale-details-newId"
  }, {
    path: "/seller-center/order/detail/:id?",
    component: _3fb954e3,
    name: "seller-center-order-detail-id"
  }, {
    path: "/seller-center/stock-up/apply/:id?",
    component: _57938002,
    name: "seller-center-stock-up-apply-id"
  }, {
    path: "/seller-center/stock-up/new/:id?",
    component: _94969718,
    name: "seller-center-stock-up-new-id"
  }, {
    path: "/seller-center/deposit-payment-record/:id?",
    component: _22bf0d90,
    name: "seller-center-deposit-payment-record-id"
  }, {
    path: "/seller-center/detailshow/:id?",
    component: _2fc53e02,
    name: "seller-center-detailshow-id"
  }, {
    path: "/seller-center/dialogueinterface/:id?",
    component: _384849f6,
    name: "seller-center-dialogueinterface-id"
  }, {
    path: "/seller-center/fault-lisclaimer-list/:id?",
    component: _063e0c82,
    name: "seller-center-fault-lisclaimer-list-id"
  }, {
    path: "/seller-center/stock-up/:id?",
    component: _f5e9433a,
    name: "seller-center-stock-up-id"
  }, {
    path: "/sellerApp/logistics/:id?",
    component: _2758bea7,
    name: "sellerApp-logistics-id"
  }, {
    path: "/",
    component: _ff7c2830,
    name: "index"
  }, {
    path: "/:lang",
    component: _389008a6,
    name: "lang"
  }, {
    path: "/:lang/login",
    component: _2851b080,
    name: "lang-login"
  }, {
    path: "/:lang/create-seller-account/entry",
    component: _6e3b46c7,
    name: "lang-create-seller-account-entry"
  }, {
    path: "/:lang/create-seller-account/step1",
    component: _4f3ac08c,
    name: "lang-create-seller-account-step1"
  }, {
    path: "/:lang/create-seller-account/step2",
    component: _4f1e918a,
    name: "lang-create-seller-account-step2"
  }, {
    path: "/:lang/create-seller-account/step3",
    component: _4f026288,
    name: "lang-create-seller-account-step3"
  }, {
    path: "/:lang/create-seller-account/step4",
    component: _4ee63386,
    name: "lang-create-seller-account-step4"
  }, {
    path: "/:lang/create-seller-account/step5",
    component: _4eca0484,
    name: "lang-create-seller-account-step5"
  }, {
    path: "/iframe/:src/:title?/:icon?",
    component: _3483ed68,
    props: true,
    name: "iframe"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
